'use client';
import { Button } from '@skin-seoul/design-system';

interface CartEmptyViewProps {
  onClickContinueShopping: () => void;
}

export const CartEmptyView = ({ onClickContinueShopping }: CartEmptyViewProps) => {
  return (
    <>
      <div className="relative p-0 flex flex-1 overflow-y-auto px-2 items-center justify-center w-full">
        <div className="flex flex-col items-center justify-center gap-3">
          <img
            src="https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/empty-cart.svg"
            alt="empty cart"
            className="w-[200px] h-[200px]"
          />

          <Button variant="dark" className="w-full rounded-[8px] uppercase" onClick={onClickContinueShopping} size="lg">
            Continue Shopping
          </Button>
        </div>
      </div>
    </>
  );
};
